import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback, useEffect } from 'react';
import {
  selectAudioId,
  selectAverageCalibrateLevel, selectIsRunningAudioService,
} from '../../store/modules/studio/selectors';
import {
  setAutoScrolling, setAverageCalibrateVolume, setCalibratingAudioService,
  setConnectingAudioService, setPlayPrompter, setRunCountdown, setRunningAudioService,
} from '../../store/modules/studio/actions';
import AudioService from '../../services/studio/AudioService';
import { notify } from '../../store/modules/notifications/actions';
import StudioNotification from './StudioNotification';

const AudioServiceInitializer = () => {
  const dispatch = useDispatch();
  const averageCalibrateLevel = useSelector(selectAverageCalibrateLevel);
  const audioId = useSelector(selectAudioId);
  const isRunning = useSelector(selectIsRunningAudioService);

  const setAutoScrollingHandler = useCallback((state: boolean) => {
    dispatch(setAutoScrolling(state));
  }, [dispatch]);


  const setConnectingAudioServiceHandler = useCallback((state: boolean) => {
    dispatch(setConnectingAudioService(state));
  }, [dispatch]);


  const setAverageCalibrateVolumeHandler = useCallback((averageCalibrateVolume: number) => {
    dispatch(setAverageCalibrateVolume(averageCalibrateVolume));
  }, [dispatch]);

  const setCalibratingAudioServiceHandler = useCallback((bool: boolean) => {
    dispatch(setCalibratingAudioService(bool));
  }, [dispatch]);

  const setRunCountDownHandler = useCallback(() => {
    dispatch(setRunCountdown());
  }, [dispatch]);

  const setPlayPrompterHandler = useCallback((value: boolean) => {
    dispatch(setPlayPrompter(value));
  }, [dispatch]);

  useEffect(() => {
    if (window.studioAudioService) {
      window.studioAudioService.updateCalibrateData(averageCalibrateLevel);
    }
  }, [averageCalibrateLevel]);

  useEffect(() => {
    if (window.studioAudioService === undefined) {
      const showNotification = (message: string) => {
        dispatch(notify({
          type: 'custom',
          message: (<StudioNotification message={message} />),
        }));
      };
      window.studioAudioService = new AudioService({
        showNotification,
        setScrolling: setAutoScrollingHandler,
        setConnecting: setConnectingAudioServiceHandler,
        averageLevel: averageCalibrateLevel,
        setAverageCalibrateLevel: setAverageCalibrateVolumeHandler,
        setCalibratingAudioService: setCalibratingAudioServiceHandler,
        setRunCountDown: setRunCountDownHandler,
        setPlayPrompterHandler,
        audioId,
      });
    }
    // eslint-disable-next-line
  }, [
    setAutoScrollingHandler,
    setConnectingAudioServiceHandler,
    averageCalibrateLevel,
    setAverageCalibrateVolumeHandler,
    setCalibratingAudioServiceHandler,
    setRunCountDownHandler,
    setPlayPrompterHandler,
    audioId,
  ]);

  useEffect(()=>{
    if(window.studioAudioService && audioId){
      window.studioAudioService.setAudioId(audioId);
      dispatch(setRunningAudioService(isRunning));
    }
// eslint-disable-next-line
  }, [audioId, dispatch])

  return null;
};
export default AudioServiceInitializer;
